import "./SuperdogInfo.less";

import React, { Component } from "react";

import superdogImage from "../../../assets/images/supermandog.svg";

class SuperdogInfo extends Component {
	render() {
		return (
			<div className="superdog-info">
				<img src={superdogImage} />
				<p className="description">{this.props.description || this.props.children}</p>
			</div>
		);
	}
}
export default SuperdogInfo;


// WEBPACK FOOTER //
// ./src/components/WizardSteps/SuperdogInfo/SuperdogInfo.js